import { useState } from 'react';
import { useSearchParams } from 'react-router';
import { ClientOnly } from 'remix-utils/client-only';

import { RegistrationEntryProvider } from '~/hooks/useRegistrationInteraction';
import useUser from '~/hooks/useUser';
import { FROM_PASSWORD_RESET_PARAM } from '~/utils/navigationContext';

import EmailLogin from './Login/LoginFlow';

export const PASSWORD_RESET_SIGN_IN_PATH = `/?${FROM_PASSWORD_RESET_PARAM}=true`;

const DISMISSED_STORAGE_KEY = 'passwordResetSignInDismissed';

function hasDismissedSignIn() {
  try {
    return sessionStorage.getItem(DISMISSED_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

function rememberDismissedSignIn() {
  try {
    sessionStorage.setItem(DISMISSED_STORAGE_KEY, 'true');
  } catch {
    // Without storage the prompt still closes; it only comes back on a refresh
  }
}

export function PasswordResetSignIn() {
  const user = useUser();
  const [searchParams] = useSearchParams();
  const [isDismissed, setIsDismissed] = useState(hasDismissedSignIn);

  if (
    isDismissed ||
    user.isLoggedIn ||
    !searchParams.has(FROM_PASSWORD_RESET_PARAM)
  ) {
    return null;
  }

  // Closing leaves the flag in the URL on purpose: removing it is a navigation,
  // which re-runs the homepage loader and fires homepage_view a second time
  function closeSignIn() {
    rememberDismissedSignIn();
    setIsDismissed(true);
  }

  return (
    <RegistrationEntryProvider entry={{ placement: 'password_reset' }}>
      <ClientOnly>
        {() => (
          <EmailLogin
            modalType="account"
            onDismiss={closeSignIn}
            postAuthOptions={{ action: 'redirect' }}
          />
        )}
      </ClientOnly>
    </RegistrationEntryProvider>
  );
}
